module.exports = __webpack_public_path__ + "static/media/close.475691c2.svg";